// @flow
import React from 'react';

import { ESTIMATE_COMMIT_DETAILS_CONFIG_MAP } from '../../configuration/estimate-commit-details';
import { GATEWAY_ADD_ON_ENABLED_BACKEND_NAME } from '../../constants';
import { BooleanSelectField } from '../../formik-utils/FormFields';

export const GatewayAddOnEnabledContainer = () => {
  const { displayName, backendFieldName, tooltip } = ESTIMATE_COMMIT_DETAILS_CONFIG_MAP.get(
    GATEWAY_ADD_ON_ENABLED_BACKEND_NAME
  );

  return (
    <BooleanSelectField
      fieldDisplayName={displayName}
      fieldName={backendFieldName}
      tooltip={tooltip}
    />
  );
};
